<template>
  <div class="ylj-page">
    <van-nav-bar title="养老金福利活动" left-arrow @click-left="$router.back()" />

    <div class="ylj-banner">
      <img src="../../assets/images/yljbj.png" alt="养老金福利活动">
    </div>

    <div class="ylj-countdown">
      <div class="countdown-title">距离首批养老金发放还有</div>
      <div class="countdown-time">
        <span>{{ countdown.day }}</span><em>天</em>
        <span>{{ countdown.hour }}</span><em>时</em>
        <span>{{ countdown.minute }}</span><em>分</em>
        <span>{{ countdown.second }}</span><em>秒</em>
      </div>
      <div class="countdown-desc">倒计时结束后，正式开始发放养老金</div>
    </div>

    <div class="ylj-balance">
      <div class="balance-main">
        <div class="balance-left">
        <div class="balance-title">
          <span>我的养老金余额</span>
          <span class="balance-detail" @click="goDetail">养老金明细 ›</span>
        </div>
          <div class="balance-num">{{ showMoney ? formatMoney(balance) : "****" }} <small>元</small></div>
        </div>
        <div class="withdraw-box" @click="withdraw">
          <img class="action-img withdraw-img" src="../../assets/images/tx.png" alt="提现">
          <div class="withdraw-title">提现</div>
          <div class="withdraw-desc">达到发放条件后<br>即可申请提现</div>
        </div>
      </div>

      <div class="balance-stat">
        <div>
          <strong>{{ signReward }}</strong>
          <span>累计签到奖励</span>
        </div>
        <div>
          <strong>{{ inviteReward }}</strong>
          <span>邀请奖励</span>
        </div>
        <div>
          <strong>{{ issuedMoney }}</strong>
          <span>已发放金额</span>
        </div>
 
      </div>
    </div>

    <div class="ylj-actions">
      <div class="action-card">
        <div class="action-icon">
          <img src="../../assets/images/qd.png" alt="签到">
        </div>
        <div class="action-content">
          <div class="action-title">每日签到</div>
          <div class="action-desc">每日签到即可领取</div>
          <div class="action-money">500元养老金</div>
        </div>
        <button type="button" :class="{ disabled: signedToday || signing }" @click="signIn">
          {{ signedToday ? "今日已签到" : signing ? "签到中..." : "立即签到" }}
        </button>
      </div>

      <div class="action-card">
        <div class="action-icon people">
          <img src="../../assets/images/yq.png" alt="邀请">
        </div>
        <div class="action-content">
          <div class="action-title">邀请好友</div>
          <div class="action-desc">好友完成注册并激活</div>
          <div class="action-money">可额外领取3000元</div>
        </div>
        <button type="button" @click="invite">立即邀请</button>
      </div>

      <div class="invite-record">
        <div class="invite-record-title">我的邀请</div>
        <div class="invite-item">
          <span>已邀请</span>
          <b>{{ inviteCount }}</b>
          <i>人</i>
        </div>
        <div class="invite-item">
          <span>已激活</span>
          <b>{{ activeCount }}</b>
          <i>人</i>
        </div>
        <div class="invite-item">
          <span>待完成</span>
          <b>{{ pendingInviteCount }}</b>
          <i>人</i>
        </div>
        <button type="button" @click="inviteRecord">邀请记录 ›</button>
      </div>
    </div>

    <!-- <div class="ylj-rule">
      <div class="rule-title">
        <span>养老金活动规则</span>
      </div>
      <div class="rule-item">
        <i>1</i>
        <span>每日签到可领取对应养老金奖励。</span>
      </div>
      <div class="rule-item">
        <i>2</i>
        <span>邀请好友完成指定条件后可获得邀请奖励。</span>
      </div>
      <div class="rule-item">
        <i>3</i>
        <span>养老金达到发放条件后可申请提现。</span>
      </div>
      <div class="rule-item">
        <i>4</i>
        <span>具体发放时间及金额以平台最终审核结果为准。</span>
      </div>
    </div> -->
  </div>
</template>

<script>
import request from "@utils/request";

export default{
  name:"Ylj",
  data(){
    return{
      showMoney:true,
      balance:0,
      signReward:0,
      inviteReward:0,
      issuedMoney:0,
      pendingMoney:0,
      inviteCount:0,
      activeCount:0,
      pendingInviteCount:0,
      signedToday:false,
      signing:false,
      isPension:0,
      countdown:{
        day:"00",
        hour:"00",
        minute:"00",
        second:"00"
      },
      timer:null
    };
  },
  created(){
    this.getYljData();
    this.status();
  },
  mounted(){
    this.startCountdown();
  },
  beforeDestroy(){
    if(this.timer){
      clearInterval(this.timer);
      this.timer=null;
    }
  },
  methods:{
    formatMoney(num){
      return Number(num||0).toLocaleString("zh-CN");
    },
getYljData(){
  request.get("/pension/index",{},{login:true}).then(res=>{
    console.log("养老金数据",res);
    if(res&&res.data&&res.data.data){
      const data=res.data.data;
      this.balance=Number(data.balance||0);
      this.signReward=Number(data.signReward||0);
      this.inviteReward=Number(data.inviteReward||0);
      this.issuedMoney=Number(data.issuedMoney||0);
      this.pendingMoney=Number(data.pendingMoney||0);
      this.signedToday=!!data.signedToday;
      this.isPension=Number(data.isPension||0);
      this.inviteCount=Number(data.inviteCount||0);
      this.activeCount=Number(data.activeCount||0);
      this.pendingInviteCount=Number(data.pendingInviteCount||0);
    }
  }).catch(err=>{
    console.log(err);
    if(err.response&&err.response.data){
      this.$dialog.error(err.response.data.msg);
    }
  });
},
    status(){
      request.get("/pension/sign/status",{},{
        login:true
      }).then(res=>{
        console.log("养老金签到状态",res);
        if(res&&res.data&&res.data.data){
          if(res.data.data.status==1){
            this.signedToday=true;
          }
        }
      }).catch(err=>{
        console.log(err);
        if(err.response&&err.response.data){
          this.$dialog.error(err.response.data.msg);
        }
      });
    },
    signIn(){
      if(this.signedToday||this.signing){
        return;
      }
      this.signing=true;
      request.post("/pension/sign/add",{},{
        login:true
      }).then(res=>{
        this.signedToday=true;
        this.getYljData();
        this.$dialog.success("签到成功，获得500元养老金");
      }).catch(err=>{
        console.log(err);
        this.signedToday=false;
        if(err.response&&err.response.data){
          this.$dialog.error(err.response.data.msg);
        }else{
          this.$dialog.error("签到失败，请稍后重试");
        }
      }).finally(()=>{
        this.signing=false;
      });
    },
    startCountdown(){
      const getTargetTime=()=>{
        const now=new Date();
        let year=now.getFullYear();
        let target=new Date(year,10,10,0,0,0);
        if(now.getTime()>=target.getTime()){
          target=new Date(year+1,10,10,0,0,0);
        }
        return target.getTime();
      };
      const targetTime=getTargetTime();
      const update=()=>{
        let total=Math.max(0,Math.floor((targetTime-Date.now())/1000));
        const day=Math.floor(total/86400);
        const hour=Math.floor((total%86400)/3600);
        const minute=Math.floor((total%3600)/60);
        const second=total%60;
        this.countdown.day=String(day).padStart(2,"0");
        this.countdown.hour=String(hour).padStart(2,"0");
        this.countdown.minute=String(minute).padStart(2,"0");
        this.countdown.second=String(second).padStart(2,"0");
        if(total<=0){
          clearInterval(this.timer);
          this.timer=null;
        }
      };
      update();
      this.timer=setInterval(update,1000);
    },
    invite(){
      if(this.isPension!==1){
        this.$dialog.error("养老金活动已关闭");
        return;
      }
      this.$router.push({path:"/invitation"});
    },
    inviteRecord(){
      this.$router.push({path:"/YljInviteRecord"});
    },
    goDetail(){
      this.$router.push({path:"/YljDetail"});
    },
    withdraw(){
      this.$dialog.success("请等待倒计时结束后统一开放提现");
    }
  }
};
</script>

<style scoped>
.ylj-page{
  min-height:100vh;
  padding-bottom:25px;
  background:#fff4df;
}
.ylj-banner{
  width:100%;
  overflow:hidden;
}
.ylj-banner img{
  display:block;
  width:100%;
  height:auto;
}
.ylj-countdown{
  margin:0 18px;
  padding:12px 10px 15px;
  text-align:center;
  background:#fff8ed;
  border-radius:0 0 18px 18px;
}
.countdown-title{
  font-size:17px;
  font-weight:bold;
  color:#8b2b17;
}
.countdown-time{
  display:flex;
  justify-content:center;
  align-items:center;
  margin-top:8px;
}
.countdown-time span{
  min-width:43px;
  height:43px;
  line-height:43px;
  border-radius:6px;
  background:#c51c17;
  color:#fff;
  font-size:25px;
  font-weight:bold;
}
.countdown-time em{
  margin:0 5px;
  color:#8d2a17;
  font-size:14px;
  font-style:normal;
  font-weight:bold;
}
.countdown-desc{
  margin-top:7px;
  color:#8b5b42;
  font-size:13px;
}
.ylj-balance{
  position:relative;
  margin:12px 15px 0;
  overflow:hidden;
  border-radius:16px;
  background:linear-gradient(135deg,#df2119,#c60d09);
  box-shadow:0 3px 8px rgba(190,30,20,.2);
}
.balance-main{
  display:flex;
  min-height:165px;
}
.balance-left{
  flex:1;
  min-width:0;
  padding:17px 15px 0;
}
.balance-title{
  display:flex;
  align-items:center;
  color:#fff5d8;
  font-size:16px;
  font-weight:500;
}
.eye{
  margin-left:6px;
  font-size:14px;
}
.balance-detail{
  margin-left:auto;
  padding:5px 9px;
  border-radius:15px;
  background:rgba(255,244,214,.95);
  color:#b1441c;
  font-size:11px;
  white-space:nowrap;
}
.balance-num{
  margin-top:12px;
  color:#fff;
  font-size:44px;
  line-height:1;
  font-weight:bold;
  letter-spacing:.5px;
}
.balance-num small{
  margin-left:2px;
  font-size:16px;
}
.withdraw-box{
  width:108px;
  padding-top:22px;
  text-align:center;
  background:linear-gradient(180deg,#fff5d7,#ffe6b1);
  color:#9c431d;
  cursor:pointer;
}
.withdraw-icon{
  width:28px;
  height:28px;
  margin:0 auto 3px;
  color:#9c431d;
  font-size:25px;
  line-height:28px;
}
.withdraw-title{
  font-size:22px;
  font-weight:bold;
}
.withdraw-desc{
  margin-top:6px;
  line-height:17px;
  font-size:11px;
}
.balance-stat{
  display:flex;
  padding:12px 0 13px;
  border-top:1px solid rgba(255,255,255,.28);
}
.balance-stat>div{
  flex:1;
  min-width:0;
  text-align:center;
  border-right:1px solid rgba(255,255,255,.22);
}
.balance-stat>div:last-child{
  border-right:0;
}
.balance-stat strong{
  display:block;
  overflow:hidden;
  color:#fff;
  font-size:17px;
  line-height:22px;
  white-space:nowrap;
}
.balance-stat span{
  display:block;
  margin-top:3px;
  color:#ffe8c6;
  font-size:10px;
  line-height:16px;
  white-space:nowrap;
}
.ylj-actions{
  display:grid;
  grid-template-columns:1fr 1fr 1fr;
  gap:8px;
  margin:12px 15px 0;
}
.action-card,.invite-record{
  display:flex;
  min-width:0;
  min-height:210px;
  padding:13px 7px 12px;
  flex-direction:column;
  align-items:center;
  border-radius:14px;
  background:#fff;
  box-shadow:0 2px 8px rgba(140,70,20,.08);
}
.action-icon{
  flex:none;
  width:44px;
  height:44px;
  margin:0 auto;
  border-radius:11px;
  background:#fff1df;
  color:#e5291e;
  text-align:center;
  line-height:44px;
  font-size:30px;
  font-weight:bold;
}
.action-icon.people{
  font-size:20px;
  letter-spacing:-2px;
}
.action-content{
  width:100%;
  margin-top:9px;
  text-align:center;
}
.action-title{
  color:#bd2117;
  font-size:14px;
  font-weight:bold;
  line-height:20px;
  white-space:nowrap;
}
.action-desc{
  min-height:34px;
  margin-top:7px;
  color:#666;
  font-size:11px;
  line-height:17px;
}
.action-money{
  min-height:32px;
  margin-top:2px;
  color:#bd2117;
  font-size:10px;
  font-weight:bold;
  line-height:16px;
}
.action-card button,.invite-record button{
  display:block;
  width:92%;
  height:35px;
  margin:auto auto 0;
  padding:0;
  border:0;
  border-radius:20px;
  background:linear-gradient(180deg,#f02e26,#d81710);
  color:#fff;
  font-size:12px;
}
.action-card button.disabled{
  background:#aaa;
}
.invite-record{
  align-items:stretch;
}
.invite-record-title{
  color:#bd2117;
  font-size:16px;
  font-weight:bold;
  line-height:22px;
}
.invite-item{
  display:flex;
  align-items:center;
  margin-top:13px;
  color:#666;
  font-size:11px;
}
.invite-item span{
  flex:1;
}
.invite-item b{
  color:#d5231b;
  font-size:17px;
  line-height:20px;
}
.invite-item i{
  margin-left:2px;
  color:#d5231b;
  font-size:11px;
  font-style:normal;
}
.invite-record button{
  width:92%;
  margin-top:auto;
  background:#fff0cf;
  color:#a35b1e;
}
.ylj-rule{
  margin:12px 15px 0;
  padding:15px 14px 16px;
  border-radius:13px;
  background:#fff;
  box-shadow:0 1px 6px rgba(140,70,20,.05);
}
.rule-title{
  display:flex;
  align-items:center;
  margin-bottom:11px;
  color:#b92016;
  font-size:16px;
  font-weight:bold;
}
.rule-title:before{
  content:"";
  width:4px;
  height:17px;
  margin-right:7px;
  border-radius:4px;
  background:#df2119;
}
.rule-item{
  display:flex;
  align-items:flex-start;
  margin-top:9px;
  color:#666;
  font-size:12px;
  line-height:19px;
}
.rule-item i{
  flex:none;
  width:17px;
  height:17px;
  margin:1px 7px 0 0;
  border-radius:50%;
  background:#fff0df;
  color:#c9271d;
  text-align:center;
  line-height:17px;
  font-size:10px;
  font-style:normal;
  font-weight:bold;
}
.rule-item span{
  flex:1;
}
@media(max-width:360px){
  .balance-num{
    font-size:38px;
  }
  .withdraw-box{
    width:95px;
  }
  .balance-detail{
    padding:4px 7px;
    font-size:10px;
  }
  .action-title{
    font-size:13px;
  }
  .action-desc{
    font-size:10px;
  }
  .action-money{
    font-size:9px;
  }
}
.action-icon{width:52px;height:52px;display:flex;align-items:center;justify-content:center;flex-shrink:0}
.action-icon img{width:52px;height:52px;display:block;object-fit:contain}
.withdraw-icon{width:52px;height:52px}
.withdraw-img{width:52px;height:52px;display:block;object-fit:contain;margin-left:22px}

</style>